import { render, staticRenderFns } from "./PeopleSwiper.vue?vue&type=template&id=d0c6a57c"
import script from "./PeopleSwiper.vue?vue&type=script&lang=js"
export * from "./PeopleSwiper.vue?vue&type=script&lang=js"
import style0 from "./PeopleSwiper.vue?vue&type=style&index=0&id=d0c6a57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports